import { render, staticRenderFns } from "./Vue2Editor.vue?vue&type=template&id=a47a7796"
import script from "./Vue2Editor.vue?vue&type=script&lang=js"
export * from "./Vue2Editor.vue?vue&type=script&lang=js"
import style0 from "./Vue2Editor.vue?vue&type=style&index=0&id=a47a7796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports